/**
 * London Smoke & Cure — clearer Njord fetch errors (CORS vs down vs API body).
 */

/** @param {unknown} err @param {string} [fallback] */
export function njordFetchErrorMessage(err, fallback = 'Request failed') {
    if (err instanceof TypeError && /fetch|network|failed/i.test(String(err.message || ''))) {
        return 'Njord API unreachable — Cloud Run njord-service may be down (503) or CORS blocked for this site. Check Cloud Run logs and that CORS_ORIGINS includes your origin (e.g. http://localhost:3000).';
    }
    if (err instanceof Error && err.message) return err.message;
    return fallback;
}
